export default __webpack_public_path__ + "static/assets/8a0ca3ba4092266d06275a104e826123.png";